export default __webpack_public_path__ + "7192bb3.png";